import React, {
	useEffect,
	useState,
	useCallback,
	Fragment,
	memo, useMemo,
} from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import ResponsiveImage, { getResponsiveImageUrl } from 'root/src/client/web/static/reusable/ResponsiveImage'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import classNames from 'classnames'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
// import Icon from 'root/src/client/web/base/Icon'
import {
	ltGtMediaQuery,
	colorsNew,
	ltMdMediaQuery,
	ltSmMediaQuery,
	gtMdMediaQuery,
	dropShadow,
	textShadow,
} from 'root/src/client/web/commonStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import urlParser from 'root/src/shared/util/urlParser'
import YTPlayer from 'root/src/client/web/base/Player/YTPlayer'
import useScript from 'root/src/client/web/hooks/useScript'
import { ytPlayerSrc } from 'root/src/shared/constants/playerUrls'
import { idKey } from 'root/src/shared/constants/keys'
import propOr from 'ramda/src/propOr'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import { GET_STARTED_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import reduce from 'ramda/src/reduce'
import isEmpty from 'ramda/src/isEmpty'
import { isVideoType, isYoutubeVideo } from 'root/src/client/util/isVideoType'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
// import { platformIconMap } from 'root/src/shared/constants/dropKeys'
import TooltipWrapper from 'root/src/client/web/base/TooltipWraper'
import { PrizesAvailableProgressBar, PointsAvailableProgressBar } from 'root/src/client/web/record/DropEvent/Progress'
import { HeroSectionStyle } from 'root/src/client/web/record/DropEvent/styles'
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'
import { useModal } from 'root/src/client/v2/common/contexts/modal.context'
import { PointsApplicationModal } from 'root/src/client/web/modal/PointsApplicationModal'
import { getDateWithTimezone } from 'root/src/shared/util/getDateWithTimezone'
import { ButtonNew as ButtonNewV2 } from 'root/src/client/v2/common/components/form/ButtonNew'
import Link from 'next/link'
import { PointsFAQLink } from 'root/src/client/v2/common/components/PointsFAQLink'
import { ReclaimKeySelectionModal } from 'root/src/client/v2/drop/features/KeySelectionModal/components/ReclaimKeySelectionModal'
import { FaSteam, FaLink, FaDiscord, FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { RewardType } from 'root/src/shared/rewards/constants'
import { dropKeyPlatformRegionsOptionsMap } from 'root/src/shared/constants/dropKeys'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { MARKDOWN_COMPONENTS } from 'root/src/client/util/markdown'

const dropIsOverLayoutStyle = {
	root: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		left: -15,
		top: -15,
		padding: 15,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 30,
		zIndex: 2,
		background: 'rgba(0, 0, 0, .75)',
		[ltGtMediaQuery]: {
			top: 0,
			padding: 0,
			left: 0,
			borderRadius: 0,
			transform: 'none',
			position: 'fixed',
			height: '-webkit-fill-available',
		},
	},
	gameOver: {
		position: 'sticky',
		top: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		border: '10px solid #ff0000',
		borderRadius: 30,
		margin: [[12, 0]],
		[ltSmMediaQuery]: {
			margin: 12,
			fontSize: 50,
		},
	},
	gameOverText: {
		color: '#ff0000',
		fontFamily: 'Bodoni Moda, monospace',
		fontWeight: 700,
		textAlign: 'center',
		textShadow: '4px 4px 5px rgba(0, 0, 0, 0.65)',
		userSelect: 'none',
		padding: [[5, 40]],
		[gtMdMediaQuery]: {
			fontSize: 95,
		},
		[ltMdMediaQuery]: {
			fontSize: 70,
		},
		[ltSmMediaQuery]: {
			padding: [[5, 10]],
			fontSize: 50,
		},
	},
	shadowText: {
		filter: dropShadow(colorsNew.primary),
	},
	columnText: {
		textShadow: textShadow('rgba(0, 0, 0, .25)'),
		textAlign: 'center',
		margin: [[5, 0]],
	},
	textBold: {
		fontWeight: 700,
	},
	link: {
		cursor: 'pointer',
	},
}

const DropIsOverLayout = withStyles(dropIsOverLayoutStyle, { name: 'MuiDropIsOverLayout' })(
	memo(({ classes, label, pushRouteFn }) => (
		<div
			className={classes.root}
		>
			<div className={classes.gameOver}>
				<Typography
					color="#ff0000"
					variant={typographyVariants.heading1}
					className={classes.gameOverText}
				>
					GAME OVER
				</Typography>
			</div>
			<Typography
				className={classNames(
					classes.columnText,
					classes.textBold,
				)}
				variant={typographyVariants.paragraphBold}
			>
				CONTINUE?
			</Typography>
			<Typography
				onClick={() => pushRouteFn()}
				className={classNames(
					classes.columnText,
					classes.shadowText,
					classes.link,
				)}
				variant={typographyVariants.heading1}
			>
				{label}
			</Typography>
		</div>
	)),
)

const MediaPlayer = ({ classes, mediaArr }) => {
	const [activeMedia, setActiveMedia] = useState(0)
	const [canScrollPrev, setCanScrollPrev] = useState(false)
	const [canScrollNext, setCanScrollNext] = useState(false)
	const [emblaRef, emblaApi] = useEmblaCarousel({
		loop: false,
		align: 'start',
		watchDrag: mediaArr.length > 1,
	})
	const [ytLoaded] = useScript(ytPlayerSrc)
	const [windowWidth] = useWindowSize()
	const isMobile = windowWidth < 500
	// Warm the browser cache for every slide image up front so clicking a
	// thumbnail reveals the image instantly instead of showing the slide's
	// black background while LazyLoadImage starts the fetch.
	useEffect(() => {
		mediaArr.forEach((item) => {
			if (!item || item.videoId || isVideoType(item.url || '')) return
			const src = getResponsiveImageUrl(item, { isMobile })
			if (!src) return
			const img = new Image()
			img.src = src
		})
	}, [mediaArr, isMobile])

	useEffect(() => {
		if (!emblaApi) return undefined
		const onSelect = () => {
			setActiveMedia(emblaApi.selectedScrollSnap())
			setCanScrollPrev(emblaApi.canScrollPrev())
			setCanScrollNext(emblaApi.canScrollNext())
		}
		onSelect()
		emblaApi.on('select', onSelect)
		emblaApi.on('reInit', onSelect)
		return () => {
			emblaApi.off('select', onSelect)
			emblaApi.off('reInit', onSelect)
		}
	}, [emblaApi])

	const onThumbClick = useCallback((idx) => {
		if (!emblaApi) {
			setActiveMedia(idx)
			return
		}
		emblaApi.scrollTo(idx)
	}, [emblaApi])

	const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi])
	const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi])

	return (
		<div className={classes.media}>
			<div className={classes.playerWrapper}>
				<div className={classes.playerViewport} ref={emblaRef}>
					<div className={classes.playerContainer}>
						{mediaArr.map(
							item => (
								<div
									className={classes.playerSlide}
									key={item.fileHash ? item.fileHash : item.url}
								>
									{item.videoId ? (
										<Fragment>
											{ytLoaded && (
												<YTPlayer
													videoId={item.videoId}
												/>
											)}
										</Fragment>

									) : (
										<ResponsiveImage
											imageObj={item}
											controls
										/>
									)}
								</div>
							),
							mediaArr,
						)}
					</div>
				</div>
				{mediaArr.length > 1 && (
					<Fragment>
						<button
							type="button"
							aria-label="Previous media"
							onClick={scrollPrev}
							disabled={!canScrollPrev}
							className={classNames(classes.navArrow, classes.navArrowPrev)}
						>
							<FaChevronLeft size={18} />
						</button>
						<button
							type="button"
							aria-label="Next media"
							onClick={scrollNext}
							disabled={!canScrollNext}
							className={classNames(classes.navArrow, classes.navArrowNext)}
						>
							<FaChevronRight size={18} />
						</button>
					</Fragment>
				)}
			</div>
			<div className={classes.thumbnails}>
				{mediaArr.map(
					(item, idx) => (
						<div
							className={classNames(
								classes.thumbnailContainer,
								idx === activeMedia && classes.activeThumbnail,
							)}
							onClick={() => onThumbClick(idx)}
							key={item.fileHash ? item.fileHash : item.url}
						>
							{(item.videoId || isVideoType(item.url || '')) && (
								<div className={
									classes.playIconWrapper}
								>
									<FontAwesomeIcon icon={faPlay} />
								</div>
							)}
							{item.videoId ? (
								<img
									src={`https://img.youtube.com/vi/${item.videoId}/0.jpg`}
									alt="thumbnail"
									width="118"
									height="65"
								/>
							) : (
								<ResponsiveImage
									imageObj={item}
									thumbnail
									width="118"
									height="65"
								/>
							)}
						</div>
					),
				)}
			</div>
		</div>
	)
}

const Helper = ({
	classes, isAuthenticated, comingSoon,
	emailSubscription, toggleEmailSubscription, displayModal,
}) => {
	const [error, setError] = useState('')

	if (isAuthenticated && !comingSoon) {
		return null
	}

	const content = isAuthenticated && comingSoon
		? (emailSubscription
			? {
				text: 'Cancel email notification',
				buttonLabel: 'Drop joined',
				onClick: () => toggleEmailSubscription(setError),
			} : {
				text: 'Want to be notified when this drop goes live?',
				buttonLabel: 'Notify me',
				onClick: () => toggleEmailSubscription(setError),
			})
		: {
			text: 'Ready to do a drop but dont know where to begin?',
			buttonLabel: 'Get Started',
			onClick: () => displayModal(GET_STARTED_MODULE_ID),
		}
	return (
		<TooltipWrapper tooltipText={error} visible>
			<div className={classes.helperContainer}>
				<p className={classes.helperText}>
					{content.text}
				</p>
				<div className={classes.helperAction}>
					<ButtonNew
						className={classes.helperActionButton}
						onClick={content.onClick}
					>
						{content.buttonLabel}
					</ButtonNew>
				</div>
			</div>
		</TooltipWrapper>
	)
}

const getGameDescriptionTextClassname = (campaignId) => {
	// quick temp inline style for a specific campaign
	if (campaignId === '1478dc7a-b03b-473d-ad50-2b5173e1e19d') {
		return 'gameDescriptionTextInline'
	}
	return undefined
}

const HeroSection = ({
	classes, gameName, gameDescriptionBody, rating, brandName,
	assets, tags, dares, isAuthenticated, campaignId,
	isDropOver, isBrand, redirectAndPrePopulate,
	displayModal, comingSoon, emailSubscription, toggleEmailSubscription, totalPrizes,
	initialProduct, isGameFree, canEarnPoints, pointsLimit, pointsAwarded, isAdmin,
	canUserReclaimReservation, displayHowToEarnPointsModal,	displaySponsorshipDetailsModal,
	pointsReserved, isCreator, isCommunityDrop, youtubeURL,
	pointsApplicationState, pointsApplicationsEnabled, liveDate, isCreatorPointsAllowlisted, discordInvitationLink,
	canUserReclaimInitialReward, utmLink, platform, isAbleToParticipate,
}) => {
	const modal = useModal()
	const assetsUpdated = [
		...(youtubeURL ? [{ url: youtubeURL }] : []),
		...assets,
	]
	const getYoutubeId = video => propOr('', idKey, urlParser(video))
	const mediaArr = reduce((acc, curr) => {
		if (!curr) return acc

		const isVideo = isVideoType(curr?.url || '')
		const isYoutube = isYoutubeVideo(curr?.url || '')

		return [
			...acc,
			{
				...(isYoutube ? { videoId: getYoutubeId(curr.url) } : {}),
				...(isVideo ? {
					...curr,
					mobile: addHttpsProtocol(curr.url),
					desktop: addHttpsProtocol(curr.url),
				} : curr),
			},
		]
	}, [], assetsUpdated)

	const pushRouteFn = isBrand
		? () => pushRouteClient({ routeId: routeUrls.addCampaign() })
		: () => pushRouteClient({ routeId: routeUrls.drops() })

	const displaySignUpModule = () => {
		if (!isAuthenticated) {
			displayModal(GET_STARTED_MODULE_ID)
		}
	}

	const isShowPrizesProgress = totalPrizes && !isGameFree
	const isShowPointsProgress = (canEarnPoints || isAdmin) && pointsLimit

	const [canReclaimReward, setCanReclaimReward] = useState(canUserReclaimInitialReward)

	const regions = useMemo(() => {
		const regionsSet = new Set(initialProduct?.map((product) => {
			if (product.type !== RewardType.KEY) {
				return undefined
			}
			return dropKeyPlatformRegionsOptionsMap[product.platform]
				?.find(option => option.value === product.region)
				?.label
		}).filter(Boolean) || [])
		return Array.from(regionsSet)
	}, [initialProduct])

	return (
		<div className={classes.heroSectionContainer}>
			{isDropOver && !comingSoon && (
				<DropIsOverLayout
					redirectAndPrePopulate={redirectAndPrePopulate}
					label={isBrand
						? 'Launch a New Campaign'
						: 'CHECK OUT OUR ACTIVE DROPS'
					}
					pushRouteFn={pushRouteFn}
				/>
			)}
			<div className="flex flex-col md:flex-row gap-8">
				<div className={classes.gameSection}>
					<div className={classes.gameInfo}>
						<div className={classes.gameDescription}>
							<Typography className={classes?.[getGameDescriptionTextClassname(campaignId)]} variant={typographyVariants.heading1}>
								{gameName}
							</Typography>
							<div className={classes.subHeadingContainer}>
								<Typography color={colorsNew.light3} variant={typographyVariants.microBold}>
									{brandName}
								</Typography>
								{rating && (
									<div>
										<Typography color={colorsNew.light3} variant={typographyVariants.micro}>
											{'ALL REVIEWS: '}
										</Typography>
										<Typography color={colorsNew.light3} variant={typographyVariants.microBold}>
											{`${rating.label} (${rating.amount})`}
										</Typography>
									</div>
								)}
							</div>
							{comingSoon && (
								<div className="py-2">
									<Typography color={colorsNew.light3} variant={typographyVariants.heading4}>
										Drop starts {getDateWithTimezone(liveDate)}
									</Typography>
								</div>
							)}
							<Typography variant={typographyVariants.small}>
								<Markdown
									remarkPlugins={[remarkGfm]}
									components={MARKDOWN_COMPONENTS}
								>
									{gameDescriptionBody}
								</Markdown>
							</Typography>
						</div>
						<div className={classes.tags}>
							{tags && (
								<div>
									<Typography variant={typographyVariants.micro} color={colorsNew.light3}>
										TAGS
									</Typography>
									<div className={classes.tagGroup}>
										{tags.map(label => (
											<div className={classes.pile} key={label}>
												<Typography variant={typographyVariants.microBold}>{label}</Typography>
											</div>
										))}
									</div>
								</div>
							)}
							<div>
								<Typography
									variant={typographyVariants.micro}
									color={colorsNew.light3}
								>
									LOCATIONS
								</Typography>
								<div className={classes.tagGroup}>
									{isEmpty(regions) ? (
										<div className={classes.pile}>
											<Typography variant={typographyVariants.microBold}>
												Worldwide
											</Typography>
										</div>
									) : (
										regions.map(label => (
											<div className={classes.pile} key={label}>
												<Typography variant={typographyVariants.microBold}>
													{label}
												</Typography>
											</div>
										))
									)}
								</div>
							</div>
							<div className="flex flex-col gap-0.5">
								{discordInvitationLink && <div><DiscordInvitationButton link={discordInvitationLink} /></div>}
								{utmLink && <div><DropUrlButton platform={platform} url={utmLink} /></div>}
							</div>
						</div>
					</div>
				</div>
				<div className={classes.daresSliderSection}>
					<Helper
						{...{
							classes,
							isAuthenticated,
							comingSoon,
							emailSubscription,
							toggleEmailSubscription,
							displayModal,
						}}
					/>
					{
						(canEarnPoints
						&& pointsApplicationsEnabled
						&& pointsApplicationState === undefined
						&& pointsLimit - pointsAwarded > 0
						&& !isCreatorPointsAllowlisted
						&& isAbleToParticipate)
							? (
								<div className={classes.sponsorshipContainer}>
									<ButtonNew
										onClick={() => modal.show(<PointsApplicationModal />)}
										className="w-[260px]"
									>
										APPLY FOR POINTS
									</ButtonNew>
								</div>
							) : undefined}
					{isCreator ? (
						<div className={classNames(classes.sponsorshipContainer, 'w-[260px]')}>
							<ButtonNew onClick={displaySponsorshipDetailsModal}>
								{	isCommunityDrop ? 'SEE PARTICIPATION DETAILS' : 'SEE SPONSORSHIP DETAILS' }
							</ButtonNew>
						</div>
					) : undefined}
					{(canReclaimReward) && (
						<div className={classNames(classes.sponsorshipContainer, 'w-[260px]')}>
							<ButtonNew onClick={() => modal.show(
								<ReclaimKeySelectionModal
									drop={{ id: campaignId, isGameFree, dares, initialProduct }}
									onSuccess={() => setCanReclaimReward(false)}
								/>,
							)}
							>
								RE-CLAIM KEY
							</ButtonNew>
						</div>
					)}
					{(isCreator && (isShowPointsProgress || isShowPrizesProgress)) ? (
						<div className={classes.horizontalLine} />
					) : undefined}
					{isShowPrizesProgress ? (
						<PrizesAvailableProgressBar
							isAuthenticated={isAuthenticated}
							initialProduct={initialProduct}
							comingSoon={comingSoon}
							displaySignUpModule={displaySignUpModule}
						/>
					) : undefined}
					{isShowPointsProgress && (
						<PointsAvailableProgressBar
							pointsLimit={pointsLimit}
							pointsAwarded={pointsAwarded}
							pointsReserved={pointsReserved}
							canUserReclaimReservation={canUserReclaimReservation}
							displayHowToEarnPointsModal={displayHowToEarnPointsModal}
						/>
					)}
					{isShowPointsProgress && (
						<PointsFAQLink />
					)}
				</div>

			</div>
			{mediaArr.length > 0 && (
				<MediaPlayer
					classes={classes}
					mediaArr={mediaArr}
				/>
			)}
		</div>
	)
}

const DropUrlButton = memo(({ url, platform }) => {
	const Icon = platform === 'steam'
		? <FaSteam size={18} />
		: <FaLink size={18} />
	return (
		<Link href={url} passHref>
			<ButtonNewV2
				className="px-4 py-0.5"
				type="button"
				asChild
			>
				<a target="_blank">
					{Icon}
				</a>
			</ButtonNewV2>
		</Link>
	)
})

const DiscordInvitationButton = memo(({ link }) => (
	<Link href={link} passHref>
		<ButtonNewV2
			title="Join our Discord"
			className="px-4 py-0.5"
			type="button"
			asChild
		>
			<a target="_blank">
				<FaDiscord size={18} aria-label="Discord" />
			</a>
		</ButtonNewV2>
	</Link>
))

export default withStyles(HeroSectionStyle, { name: 'MuiHeroSection' })(HeroSection)
